module.exports = __webpack_public_path__ + "img/pdf_exibir.be8a6294.png";